import { render, staticRenderFns } from "./SyncAuto.vue?vue&type=template&id=06ac114a&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SyncAuto.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/icons/SyncAuto.vue
// module id = 2441
// module chunks = 1